import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as urlService from "../../view/urlService";
// import ImportRulesButton from "./ImportRulesButton";
// import ImportOnlineRulesButton from "./ImportOnlineRulesButton";
import { TableContext } from "../../index";
import ImportRulesModal from "./ImportRulesModal";
//import { PopupContext, TableContext } from "../../index";
// import { getConfirmPopup } from "../../view/popup/PopupContainer";
// import * as ruleService from "../ruleService";
//import { useMsbTableHelper } from "./useMsbTableHelper";
import RuleActionsDropdown from "./RuleActionsDropdown";
import SearchInputV2 from "../../view/SearchInputV2";
import { Download } from "lucide-react";


function MsbTableHeader({ userCapability }) {

    const [showModal, setShowModal] = useState(false);

    //const { setPopup } = useContext(PopupContext);
    const { config } = useContext(TableContext);
    //const helper = useMsbTableHelper();
    const location = useLocation();
    const history = useHistory();

    const [tableTitle, setTableTitle] = useState('Rules');

    // Search term state (feeds into URL for MsbTable filtering)
    const [searchTerm, setSearchTerm] = useState('');

    // //#region Set User Capabilities
    // const [addRuleCapability, setAddRuleCapability] = useState(-1);
    // //const [removeRuleCapability, setRemoveRuleCapability] = useState(-1);
    // const [importOnlineRulesCapability, setImportOnlineRulesCapability] = useState(-1);
    // const [importRulesCapability, setImportRulesCapability] = useState(-1);
    // const [manageParameterCapability, setManageParameterCapability] = useState(-1);
    // useEffect(() => {
    //     if (userCapability) {
    //         const addRulePermission = userCapability.find(item =>
    //             item.component === "addrule" && item.type === "field")?.permission;
    //         setAddRuleCapability(addRulePermission);

    //         // const removeRulePermission = userCapability.find(item =>
    //         //     item.component === "removerule" && item.type === "field")?.permission;
    //         // setRemoveRuleCapability(removeRulePermission);

    //         const importOnlineRulesPermission = userCapability.find(item =>
    //             item.component === "importonlinerules" && item.type === "field")?.permission;
    //         setImportOnlineRulesCapability(importOnlineRulesPermission);

    //         const importRulesPermission = userCapability.find(item =>
    //             item.component === "importrules" && item.type === "field")?.permission;
    //         setImportRulesCapability(importRulesPermission);

    //         const manageParameterPermission = userCapability.find(item =>
    //             item.component === "manageparameter" && item.type === "field")?.permission;
    //         setManageParameterCapability(manageParameterPermission);
    //     }
    //     /* eslint-disable react-hooks/exhaustive-deps */
    // }, []);
    // //#endregion

    // const onRemoveRulesClick = () => {
    //     const onConfirm = async () => {
    //         if (!config.selected || config.selected.length === 0) {
    //             return showWarningToast('No selected rules to delete', 'Remove Rule', 'aborted');
    //         }
    //         ruleService.removeList(config.selected)
    //             .then((success) => {
    //                 if (success) {
    //                     helper.hardReload();
    //                     showSuccessToast('Selected rules were removed', 'Remove Rule', 'success');
    //                 } else {
    //                     showDangerToast('Something went wrong', 'Remove Rule');
    //                 }
    //             });
    //     }

    //     setPopup(
    //         getConfirmPopup('Are you sure?',
    //             'Remove Rule',
    //             () => onConfirm()
    //         )
    //     );

    // }

    //changed the text to MSB Rules by Octopus Nov 30,2022
    useEffect(() => {
        setTableTitle(urlService.getParams().tableTitle || 'Baseline Rules');
    }, [location.search])

    // Search handler — pushes 'name' filter into URL (same logic as MsbTableManagement)
    const onSearch = (value) => {
        const caseInsensitiveValue = value ? value.toLowerCase() : value; // Convert to lowercase if value is not empty
        history.push({
            pathname: history.pathname,
            search: caseInsensitiveValue ? urlService.updateFilters('name', caseInsensitiveValue) : urlService.removeFilter('name')
        });
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        onSearch(value);
    };

    const onResetClick = () => {
        setSearchTerm('');
        history.push('/msb');
    };

// return (
//         <div className="card-header">
//             <h2 className="card-title">
//                 {tableTitle}
//             </h2>
//             <div className="card-tools">
//                 <div className="row"> 
//                     {/* 
//                     <div onClick={addRuleCapability === 0 ? null : () => history.push('/add-rules')}
//                         className={`oct_card-btn btn oct_btn-secondary ${addRuleCapability === 0 ? 'disabled' : ''}`}>
//                         Add Rule
//                     </div> 
//                      <div onClick={removeRuleCapability === 0 ? null : () => onRemoveRulesClick()}
//                         className={`oct_card-btn btn oct_btn-secondary ${removeRuleCapability === 0 ? 'disabled' : ''}`}>
//                         Remove Rule
//                     </div> 
//                      <div onClick={manageParameterCapability === 0 ? null : () => history.push('/parameters')}
//                         className={`oct_card-btn btn oct_btn-secondary ${manageParameterCapability === 0 ? 'disabled' : ''}`}>
//                         Manage Parameters
//                     </div> 
//                     */}


//                     {showModal && <ImportRulesModal handleClose={() => setShowModal(false)} handleCreate={handleCreate} />}
//                      <div onClick={() => setShowModal(true)}
//                         className={`oct_card-btn btn oct_btn-secondary`}>
//                         Import Rules
//                     </div>
//                     {/* <ImportOnlineRulesButton disabled={importOnlineRulesCapability === 0 ? true : false} />
//                     <ImportRulesButton disabled={importRulesCapability === 0 ? true : false} /> */}
//                     <RuleActionsDropdown selectedRules={config.rules}/>
//                     {/* <div onClick={() => notImplemented()} className="oct_card-btn btn oct_btn-secondary">
//                         Export Data
//                     </div> */}
//                 </div>
//             </div>
//         </div>
//     );

    return (
        <>
            {/* Row 1: Title */}
            <div className="oct_analysis-header-v2 mt-0">
                <div className="oct_analysis-title-section">
                    <h2>{tableTitle}</h2>
                </div>
            </div>

            {/* Row 2: Filters + Buttons, Row 3: Search */}
            <div className="oct_filter-section-v2">
                <div className="row align-items-end">
                    {/* Col 1: Actions dropdown */}
                    <div className="col">
                        <label className="oct_filter-label">ACTIONS:</label>
                        <RuleActionsDropdown selectedRules={config.rules} />
                    </div>

                    {/* Col 2: Import Rules + Reset buttons */}
                    <div className="col d-flex align-items-end justify-content-end">
                        {showModal && <ImportRulesModal handleClose={() => setShowModal(false)} />}
                        {/* 
                        <button
                            onClick={addRuleCapability === 0 ? null : () => history.push('/add-rules')}
                            className={`oct_btn-outline-v2 mr-2 ${addRuleCapability === 0 ? 'disabled' : ''}`}>
                            Add Rule
                        </button>
                        <button
                            onClick={manageParameterCapability === 0 ? null : () => history.push('/parameters')}
                            className={`oct_btn-outline-v2 mr-2 ${manageParameterCapability === 0 ? 'disabled' : ''}`}>
                            Manage Parameters
                        </button>
                        */}
                        <button
                            onClick={() => setShowModal(true)}
                            className="oct_btn-export-v2 mr-2">
                                                        <Download className="oct_icon" />

                            Import Rules
                        </button>
                        {/* <ImportOnlineRulesButton disabled={importOnlineRulesCapability === 0 ? true : false} />
                        <ImportRulesButton disabled={importRulesCapability === 0 ? true : false} /> */}
                        <button
                            onClick={onResetClick}
                            className="oct_btn-outline-v2">
                            Reset
                        </button>
                        {/* <button onClick={() => notImplemented()} className="oct_btn-export-v2">
                            Export Data
                        </button> */}
                    </div>
                </div>

                {/* Row 3: Search */}
                <div className="mt-3">
                    <SearchInputV2
                        value={searchTerm}
                        onChange={handleSearchChange}
                        placeholder="Search standards..."
                        className="m-0"
                    />
                </div>
            </div>
        </>
    );
}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default connect(mapStateToProps)(MsbTableHeader);
